
import Vue from 'vue'

const actions = {

    async SalesByMonth(_, filterRequest) {

        try {
            const result = await Vue.prototype.$vanKirkApi.post("report/sales-by-month", filterRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listReport = result.data.result;

                return listReport;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list report by month: [${ex}]`
            };
        }
    },

    async SalesByStatus(_, filterRequest) {

        try {
            const result = await Vue.prototype.$vanKirkApi.post("report/sales-by-status", filterRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listReport = result.data.result;

                return listReport;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list report by status: [${ex}]`
            };
        }
    },

    async SalesBySalesPerson(_, filterRequest) {

        try {
            const result = await Vue.prototype.$vanKirkApi.post("report/sales-by-salesperson", filterRequest, 
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listReport = result.data.result;

                return listReport;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list report by sales person: [${ex}]`
            };
        }
    },

    async SalesBySalesPersonAnalytical(_, filterRequest) {

        try {
            const result = await Vue.prototype.$vanKirkApi.post("report/sales-by-salesperson-analytical", filterRequest, 
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listReport = result.data.result;

                return listReport;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list report by sales person analytical: [${ex}]`
            };
        }
    },

    async MaterialRequisitionByProduct(_, filterRequest) {

        try {
            const result = await Vue.prototype.$vanKirkApi.post("report/material-requisition-by-product", filterRequest, 
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listReport = result.data.result;

                return listReport;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list report material requisition by product: [${ex}]`
            };
        }
    },

    async MaterialRequisitionByProject(_, filterRequest) {

        try {
            const result = await Vue.prototype.$vanKirkApi.post("report/material-requisition-by-project", filterRequest, 
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listReport = result.data.result;

                return listReport;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list report material requisition by project: [${ex}]`
            };
        }
    },

    async JobsAging(_, filterRequest) {

        try {
            const result = await Vue.prototype.$vanKirkApi.post("report/jobs-aging", filterRequest, 
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listReport = result.data.result;

                return listReport;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list report jobs aging: [${ex}]`
            };
        }
    },

    async SupervisorPerformance(_, filterRequest) {

        try {
            const result = await Vue.prototype.$vanKirkApi.post("report/supervisor-performance", filterRequest, 
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listReport = result.data.result;

                return listReport;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list report supervisor performance: [${ex}]`
            };
        }
    },

    async UserPerformance(_, filterRequest) {

        try {
            const result = await Vue.prototype.$vanKirkApi.post("report/user-performance", filterRequest, 
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listReport = result.data.result;

                return listReport;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list report user performance: [${ex}]`
            };
        }
    },

    async CoverageRequestBySalesPerson(_, filterRequest) {

        try {
            const result = await Vue.prototype.$vanKirkApi.post("report/coverage-request-by-salesperson", filterRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listReport = result.data.result;

                return listReport;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list coverage request summary: [${ex}]`
            };
        }
    },

    async CoverageRequestAnalytical(_, filterRequest) {

        try {
            const result = await Vue.prototype.$vanKirkApi.post("report/coverage-request-analytical", filterRequest,
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listReport = result.data.result;

                return listReport;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list coverage request analytical: [${ex}]`
            };
        }
    },

    async MultiTrackReport() {

        try {
            const result = await Vue.prototype.$vanKirkApi.get("report/multi-track", 
            {
                headers: {
                    "content-type": "application/json"
                }
            });

            if (result.data) {
                const listReport = result.data.result;

                return listReport;
            }
            else {
                return [];
            }
        }
        catch(ex) {
            return {
                success: false,
                message: `Error to list multi track report: [${ex}]`
            };
        }
    },
}

export default {
    namespaced: true,
    actions
}